import { atom } from 'recoil';

export const toggleEditWarehouse = atom({
  key: 'toggle_edit_warehouse',
  default: false,
});

export const toggleEditWarehouseConfig = atom({
  key: 'toggle_edit_warehouse_config',
  default: false,
});
